import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import { CircularProgress } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import CNPDescription from "./CNPDescription";
import  { useParcelCNPs } from '../../../../adapters/cnp'

import { useAuth } from '@graniot/common/context/AuthContext'
import CenteredProgress from '@graniot/common/utils/centeredprogress'
import FormCNP from "./FormCNP";

const useStyles = makeStyles((theme) => ({
  prgList: {
    height: 500,
  },
}));

function VegetationNutrition({ parcel, width }) {
	const [createCNP, setCreateCNP] = React.useState(false)
  const { user } = useAuth()
  const { isLoading, data, error, isFetching, refetch } = useParcelCNPs(user,  parcel);

  if (isLoading) return <CenteredProgress/>

  if (createCNP) return <FormCNP parcel={parcel} setCreateCNP={setCreateCNP}/>

  return <CNPDescription setCreateCNP={setCreateCNP}/> 
}

export default withWidth()(VegetationNutrition);
